import React from "react";

export default function CondoGuide() {
  return (
    <>
      <h1>Condo Guide</h1>
    </>
  );
}
